// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photo[data-v-f7e21810]{width:30px;height:30px;border-radius:100%;margin-right:10px;border:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
